<template>
  <div>

      <h5>メッセージ一覧</h5>
      <hr>
      <div class="py-3 contents">
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th>ステータス</th>
              <th>相手の名前</th>
              <th>内容</th>
              <th>送受信日時</th>
            </tr>
            <tr v-for="(message, index) in allGetMessages">
              <td @click="jumpMessageDetail(message['message']['id'], message['message']['status'], message['you']['id'])">
                {{ get_hash_value(status, message['message']['status']) }}
              </td>
              <td @click="jumpMessageDetail(message['message']['id'], message['message']['status'], message['you']['id'])">
                <p v-if="message['you']['user_type'] == 1 || message['you']['user_type'] == 2 || message['you']['user_type'] == 3" class="m-0">
                  <span v-if="message['you']['user_type'] == 2">
                    <strong v-if="message['you']['legal_person']==1">{{ cinit(message['you']['corp_name'], '-') }}</strong>
                    <strong v-else-if="message['you']['legal_person']==0">{{ cinit(message['you']['store_name'], '-') }}</strong>
                  </span>
                  <span>{{ getUserName(message['you']) }}</span>
                </p>
                <p v-else-if="message['you']['user_type'] == 9" class="m-0">
                  <span>運営者</span>
                </p>
              </td>
              <td @click="jumpMessageDetail(message['message']['id'], message['message']['status'], message['you']['id'])">
                <span v-if="String(message['message']['last_send_users_id']) != String(message['i']['id'])" style="background-color: #fbfcad;font-size: 0.8rem;padding: 3px;border-radius: 6px;color: #524f4f;display: inline-block;margin-right: 4px;">未返信</span>
                <span style="white-space: pre-wrap;">{{ message['message']['contents'] }}</span>
              </td>
              <td @click="jumpMessageDetail(message['message']['id'], message['message']['status'], message['you']['id'])">
                {{ convert_jst_for_message(message['message']['updated_at']) }}
              </td>
            </tr>
          </table>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  props: { 
    user: Object
  },
  data() {
		const status = [
			{"no":"2","name":"購入申し込み"},
			{"no":"1","name":"試弾申し込み"},
			{"no":"0","name":"問い合わせ"},
			{"no":"9","name":"運営者問い合わせ"},
		];
    return {
      status,
      display: 9, // '':すべて 2:購入申し込み者 1:試弾申し込み者 0:問い合わせ 9:運営
      messages: [],
    }
  },
	methods: {
	  jumpMessageDetail: function(id, status, users_id){
      window.open('/message/'+String(users_id)+'/'+String(status)+'/'+String(id), '_blank')
      return false;
        // this.$router.push({path: '/message/'+String(users_id)+'/'+String(status)+'/'+String(id)});
	  },
	  async get_message() {
		  this.$store.dispatch('message/get_message', {
        status: this.display,
      }).then(res => {
		    console.log(res);
		    let ret = res.data.messages;
		    this.messages = ret['messages'];
		    console.log(this.messages);
        window.scrollTo({
          top: 0,
        });
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
  },
	created() {
		this.get_message();
	},
	computed: {
		allGetMessages: function() {
			return this.messages;
		},
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/admin/message.vue